"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18.7",
    width: "24",
    height: "18.7"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5,18.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S6.4,18.7,5,18.7z M5,14.7c-0.8,0-1.5,0.7-1.5,1.5 c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C6.5,15.4,5.8,14.7,5,14.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19,18.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S20.4,18.7,19,18.7z M19,14.7c-0.8,0-1.5,0.7-1.5,1.5 c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C20.5,15.4,19.8,14.7,19,14.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,16.7H7c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h10c0.3,0,0.5,0.2,0.5,0.5C17.5,16.5,17.3,16.7,17,16.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.5,9.7c-0.1,0-0.2,0-0.2-0.1C4,9.5,3.9,9.2,4.1,9l1.5-3C5.6,5.8,5.8,5.7,6,5.7h1.5C7.8,5.7,8,5.9,8,6.2 S7.8,6.7,7.5,6.7H6.3L4.9,9.4C4.9,9.6,4.7,9.7,4.5,9.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3,16.7H0.5c-0.3,0-0.5-0.2-0.5-0.5v-5.5c0-0.1,0.1-0.3,0.1-0.4l2-2L4.6,4C4.7,3.8,4.8,3.7,5,3.7h4.5 c0.3,0,0.5,0.2,0.5,0.5v10c0,0.3-0.2,0.5-0.5,0.5S9,14.5,9,14.2V4.7H5.3L2.9,8.9c0,0-0.1,0.1-0.1,0.1L1,10.9v4.8h2 c0.3,0,0.5,0.2,0.5,0.5C3.5,16.5,3.3,16.7,3,16.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,16.7H21c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h2v-1H0.5c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h23 c0.3,0,0.5,0.2,0.5,0.5v2C24,16.5,23.8,16.7,23.5,16.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,14.7h-14c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5h14c0.3,0,0.5,0.2,0.5,0.5v3 C24,14.5,23.8,14.7,23.5,14.7z M10,13.7h13v-2H10V13.7z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.7",
    width: "8",
    height: "9.8"
  }));
};

exports["default"] = _default;